export function loadScriptPromise(url: string) {
  return new Promise((resolve, reject) => {
    const existsScript = document.querySelector(`script[src="${url}"]`);
    if (existsScript) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = url;

    script.onload = resolve;

    script.onerror = reject;

    document.head.appendChild(script);
  });
}
